import React, { FC } from "react";

const NotIncluded: FC = () => {
  return (
    <div style={{ marginTop: "20rem" }}>
      This content is not included in print
    </div>
  );
};

export default NotIncluded;
